import { PawPrint, Heart } from "./Doodles";

const ITEMS = [
  "Built with care",
  "Driven by compassion",
  "Build together",
  "Donate to shelters",
  "Make an impact",
  "Hands-on learning",
  "Community impact",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="mx-8 font-display text-2xl tracking-wide text-[#FBF3E3] md:text-3xl">
          {item}
        </span>
        {i % 2 === 0 ? (
          <PawPrint className="h-6 w-6 shrink-0" color="#3B82F6" />
        ) : (
          <Heart className="h-5 w-5 shrink-0" color="#E63946" />
        )}
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative z-10 -rotate-1 overflow-hidden border-y-2 border-[#16294B] bg-[#16294B] py-4"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max">
      <Strip />
      <Strip />
    </div>
  </div>
);

export default Marquee;
